// filepath: /H:/WordSense Projects/Social-casino_frontend/src/app/app.config.ts
import { ApplicationConfig, provideZoneChangeDetection, isDevMode } from '@angular/core';
import { provideRouter, withPreloading } from '@angular/router';

import { routes } from './app.routes';
import { SelectivePreloadingStrategy } from './selective-preloading.strategy';
import {
  provideClientHydration,
  withEventReplay,
  withHttpTransferCacheOptions,
} from '@angular/platform-browser';
import {
  provideHttpClient,
  withFetch,
  withInterceptors,
  HttpTransferCacheOptions,
} from '@angular/common/http';
import { provideToastr } from 'ngx-toastr';
import { provideServiceWorker } from '@angular/service-worker';
import { tokenRefreshInterceptor } from './Services/interceptors/token-refresh.interceptor';
import { clockDriftRetryInterceptor } from './Services/interceptors/clock-drift-retry.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withPreloading(SelectivePreloadingStrategy)),
    provideClientHydration(
      withHttpTransferCacheOptions({
        includePostRequests: true,
      })
    ),
    provideHttpClient(withFetch(), withInterceptors([tokenRefreshInterceptor, clockDriftRetryInterceptor])),
    provideToastr({}),
    provideServiceWorker('ngsw-worker.js', {
      // was unconditionally true — the service worker then also registers
      // under `ng serve`, and once it's controlling a tab it can keep
      // serving a cached bundle straight through a hard refresh, since a
      // normal reload doesn't bypass an already-active SW's fetch
      // interception. Gating it to production is what isDevMode was
      // imported for.
      enabled: !isDevMode(),
      registrationStrategy: 'registerImmediately',
    }),
  ],
};
